(() => {
  function previewLinks(scope) {
    const id=document.querySelector('[data-bma-shell]')?.dataset.preview;
    if(!id)return;
    scope.querySelectorAll('a[href]').forEach(link=>{
      const u=new URL(link.href,location.origin);
      if(u.origin===location.origin&&!/account|authentication|checkout/.test(u.pathname)){u.searchParams.set('preview_theme_id',id);link.href=u.href;}
    });
  }
  function menu(host) {
    if(host.dataset.bnmReady)return;host.dataset.bnmReady='true';
    const button=host.querySelector('[data-bnm-open]'),dialog=host.querySelector('[data-bnm-menu]');
    if(!button||!dialog)return;
    previewLinks(host);
    button.addEventListener('click',()=>{
      if(dialog.open){dialog.close();return;}
      if(typeof dialog.showModal==='function')dialog.showModal();else dialog.setAttribute('open','');
      button.setAttribute('aria-expanded','true');
      document.documentElement.classList.add('bnm-menu-open');
    });
    host.querySelectorAll('[data-bnm-close]').forEach(b=>b.addEventListener('click',()=>dialog.close()));
    dialog.addEventListener('close',()=>{button.setAttribute('aria-expanded','false');document.documentElement.classList.remove('bnm-menu-open');button.focus({preventScroll:true});});
    dialog.addEventListener('click',e=>{if(e.target!==dialog)return;const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();});
  }
  function selection(root) {
    if(root.dataset.bnsReady)return;root.dataset.bnsReady='true';
    const choices=[...root.querySelectorAll('[data-bns-choice]')],buy=root.querySelector('[data-bns-buy]');
    function choose(button,focus=false){
      choices.forEach(b=>{const selected=b===button;b.classList.toggle('is-selected',selected);b.setAttribute('aria-pressed',String(selected));});
      root.querySelector('[data-bns-name]').textContent=button.dataset.name;
      root.querySelector('[data-bns-prefix]').textContent=button.dataset.prefix;
      root.querySelector('[data-bns-price]').textContent=button.dataset.price;
      buy.textContent=button.dataset.cta;buy.href=button.dataset.url;previewLinks(root);
      if(focus)button.focus({preventScroll:true});
    }
    choices.forEach((button,index)=>{
      button.addEventListener('click',()=>choose(button));
      button.addEventListener('keydown',event=>{
        let next=index;
        if(event.key==='ArrowRight')next=(index+1)%choices.length;
        else if(event.key==='ArrowLeft')next=(index+choices.length-1)%choices.length;
        else if(event.key==='Home')next=0;
        else if(event.key==='End')next=choices.length-1;
        else return;
        event.preventDefault();choose(choices[next],true);
      });
    });
    previewLinks(root);
  }
  function init(scope=document){scope.querySelectorAll('[data-bnm-host]').forEach(menu);scope.querySelectorAll('[data-bns]').forEach(selection);}
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();